export default function PetBuddyIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#FFF1C9" />
      <ellipse cx="32" cy="59" rx="20" ry="3.5" fill="#000" opacity="0.15" />
      <g transform="rotate(32 50 44)">
        <ellipse cx="52" cy="36" rx="6.5" ry="12" fill="#3FBFB0" />
        <circle cx="52" cy="27" r="4" fill="#D4F5EF" />
      </g>
      <path d="M20 26C14 18 14 7 18 3C24 7 28 15 28 22Z" fill="#3FBFB0" />
      <path d="M44 26C50 18 50 7 46 3C40 7 36 15 36 22Z" fill="#3FBFB0" />
      <path d="M21 22C18 17 18 11 20 8C23 11 25 16 25 20Z" fill="#D4F5EF" />
      <path d="M43 22C46 17 46 11 44 8C41 11 39 16 39 20Z" fill="#D4F5EF" />
      <ellipse cx="32" cy="39" rx="21" ry="19" fill="#3FBFB0" />
      <ellipse cx="32" cy="49" rx="12" ry="8" fill="#D4F5EF" />
      <circle cx="25" cy="35" r="3.3" fill="#1F2A3A" />
      <circle cx="39" cy="35" r="3.3" fill="#1F2A3A" />
      <circle cx="26" cy="34" r="1.1" fill="#fff" />
      <circle cx="40" cy="34" r="1.1" fill="#fff" />
      <path d="M30 39Q32 38 34 39Q32 41.5 30 39Z" fill="#E05A7A" />
      <path d="M28.5 42Q30.2 44 32 42Q33.8 44 35.5 42" stroke="#5A1F2E" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      <ellipse cx="19" cy="41" rx="3.2" ry="1.9" fill="#FF8FB0" opacity="0.6" />
      <ellipse cx="45" cy="41" rx="3.2" ry="1.9" fill="#FF8FB0" opacity="0.6" />
    </svg>
  );
}
